/* 产引入jsencrypt实现数据RSA加密 */
import JSEncrypt from 'jsencrypt' // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
/* 产引入encryptlong实现数据RSA加密 */
import Encrypt from 'encryptlong' // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。

// ras文章链接：https://blog.csdn.net/ch_13157582015/article/details/122102410
// 密钥对生成 http://web.chacuo.net/netrsakeypair
// https://www.bejson.com/enc/rsa/

//公钥key
// const publicKey = "MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEAq9T8+pWxVoPiBY+f/RwfYwZ6KRM0KXvSoQCyDbU2jR8HfZNnSMchtuUv6hw/x7Iwfoyn/iMpO4Ihrepm0DLwpQIDAQABAkAIc04JqMjy30ODUH/mu7ZTcWMamAYtsBg4sMcQ44OORw6sUU/bssnVBNx4PiGExPrOQBRReDB0tub6VdrOukJhAiEA5DkfZuCLlswfVT1Ky1dZCy7SNy6HLYQ1iPLdLunWAc0CIQDAvtrE1aJwzNo6iamuCGpWEAkHwxk/twhP4BQyX3yyOQIgHFp0akWPUga+Bcr9ldGeQGNqvmxLYv4/4Gm7zO5EJikCIQCmBH4o5p5ZLImXvDVz2nnFEWDF180qrTuymR6sWMTuOQIhALpYfZTzIwzTbAjD8Z6sBrYr16TVVGFW0HHxI8Pr2kmF"

//公钥key
const publicKey = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKvU/PqVsVaD4gWPn/0cH2MGeikTNCl70qEAsg21No0fB32TZ0jHIbblL+ocP8eyMH6Mp/4jKTuCIa3qZtAy8KUCAwEAAQ=="

//私钥key
const privateKey = 'MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC/IXJU3kWeCFLR8MSpq4rdVIGp1cPgIXk3wZgouDhtzCsgYh9X2L8HF1zz8dmbIoZtdGG2CyfZerS+r2qn7qwe3omngG0X7rn9cvca05ovUzhwihXo44tetKfxSMjs2UIgBEY2sl74wglGEh0Cobp7WlHZ6QpVgnetp8Otl3uL53mEvaI0uMIw7TuUUgyM3fOQgmS8emSPUmT6vWyF3g7lcTIT0DWJYiXQdu36b4YSGn8wPoUOnm9qVREaS7cfYUV36PT4t//mGNySuxzNCsWt/E3rOoG1otyQLQ7WE26/qqkgk0TvAeKZ0884blZH5L/IouILJVI5Xt+ug/nl6BHfAgMBAAECggEAGnUWzoi2OloMnOMnVhVY86pvCIN+ydfYX898sKZPqWNJ1QHANPjb+K9TPrGL3d25ng0uOXTx3zkNLBg8O2LekKddhsJQV6/EL0Fq01vXTBXJCksTHVniQQng9ZWNuruYW7Y7wfaPDwBNKFX5jhO1LL4j9nY75/pXdsJyY+VEROlYnsC1kg34nnTWc0NKXjn4S6h1WIRyaLKQFAXlSo4Eec2WdrczenNfz27Qzqzs3SRaQWJdDDq949FpM2TfhjYq/l7ZVkZ0hKJneOZY+DElzZIIR2H2vCm6XfRS/VfWyu6J/5+0mTj6LigDLF+Jg8mSIkdsy4/XOgr5xA1t222KAQKBgQDq/H0fvGbmsmHY2BRZmPj1BbjSAX7I7LWv+KfiGXnR73uWLj9vHsxZ56tkk5yrV2Z0KVFFVCISUbG+RErS67oYA4W/UEe8lx/OeITmxaz0l1fc8jnzoxrH8KBAKtxbN+SukWhmuQUTIxSycdx2nyKeCQ2Dsej3KijyAlDH3yL5UQKBgQDQOPn0K3cH14/DIKaDgKPLXSoqaBUI+oOggT0Cgmvw42PEaQSFzixOw8+X66DdJ3ryCGBs6wcjy+ch8D6qGNqdTGC8D2LdaINS3N6RRdbgBirSrqrSwMwSmbesTs3CokLnpeuJ+ujZMg6J6ilpRcr+pgefu05WQ/lR7tGeIuSMLwKBgC82ATGSGZ558lyttRD3QfWAa8yNjlpx7GLpc1liwu3hzpOywP3jUy0w9WdknNJz4dquvmxOZfYGQc63S80qnR3b/1Abof4K4tIJtrHiv0f47Ccw52HCwEuxVZDuy4zsIt7LygzxWUqp/quHYsLWYA8eRH/UC7k02DsfKfmuJAmxAoGAKtZ9/hDvJSrhBcjy2P0fNZiOMzlEkptPdzb/gUOpx15QyTi92HVpQi8gx2WPq9ASiDbW97GGv4OUorPVgJMqbtAm2qnjsh9tXR/ZnlOa+G3sY3nR5RgLJAyB8C4qQM+3KgdFpRZ8zypwOUl2iZT1RVyNFvynCjJj2cpjT8Bn+rsCgYBx9R2J0SbS+KrTFd5yTeD3pnlzlc7nZ9GOsovYn1UQfPjXKCyas2AfsAp/TaT2XHFEh77KittuMfv/+nVHfQmN4rulZX0jUcRT5YoZwsftii/ysj1FBrmaS+Yyoja2ZKHHe5I89GrL5WDVs/fNjdq+gvMa47zHpFYfelzyjYqdGA=='

export default {
  /* JSEncrypt加密 */
  rsaPublicData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(publicKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  },

  /* JSEncrypt解密 */
  rsaPrivateData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPrivateKey(privateKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  },

  /* 加密 */
  encrypt(data) {
    const PUBLIC_KEY = publicKey
    var encryptor = new Encrypt()
    encryptor.setPublicKey(PUBLIC_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data)
    return result
  },

  /* 解密 - PRIVATE_KEY - 验证 */
  // 项目中只应用到了解密，未应用到加密
  decrypt(data) {
    var decrypt = new JSEncrypt();
    decrypt.setPrivateKey('-----BEGIN RSA PRIVATE KEY-----' + privateKey + '-----END RSA PRIVATE KEY-----');
    var result = decrypt.decrypt(data);
    return result
  }
}
